"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
interface CtaContent {
  eyebrow: string;
  heading: string;
  description: string;
  button: string;
  secondaryButton: string;
  standardNote: string;
}
const ctaData: Record<"en" | "zh" | "es" | "de" | "fr" | "pt", CtaContent> = {
  en: {
    eyebrow: "Custom Engineering & RFQ",
    heading: "Have a Specific Filtration Requirement?",
    description: "Share your specifications, drawings or application requirements with our team.",
    button: "Request a Quote",
    secondaryButton: "Contact Our Team",
    standardNote: "EN 10204 3.1 (on request)"
  },
  zh: {
    eyebrow: "定制工程与报价",
    heading: "您有具体的过滤需求吗？",
    description: "请与我们的团队分享您的规格、图纸或应用需求。",
    button: "获取报价",
    secondaryButton: "联系我们",
    standardNote: "EN 10204 3.1（按需提供）"
  },
  es: {
    eyebrow: "Ingeniería a medida y cotización",
    heading: "¿Tiene un requisito de filtración específico?",
    description: "Comparta sus especificaciones, planos o requisitos de aplicación con nuestro equipo.",
    button: "Solicitar presupuesto",
    secondaryButton: "Contacte con nosotros",
    standardNote: "EN 10204 3.1 (a petición)"
  },
  de: {
    eyebrow: "Kundenspezifische Fertigung & Anfrage",
    heading: "Haben Sie spezifische Filtrationsanforderungen?",
    description: "Teilen Sie Ihre Spezifikationen, Zeichnungen oder Anwendungsdaten mit unserem Team.",
    button: "Angebot anfragen",
    secondaryButton: "Kontakt aufnehmen",
    standardNote: "EN 10204 3.1 (auf Anfrage)"
  },
  fr: {
    eyebrow: "Ingénierie sur mesure et devis",
    heading: "Vous avez un besoin spécifique de filtration ?",
    description: "Partagez vos spécifications, plans ou exigences d'application avec notre équipe.",
    button: "Demander un devis",
    secondaryButton: "Nous contacter",
    standardNote: "EN 10204 3.1 (sur demande)"
  },
  pt: {
    eyebrow: "Engenharia sob medida e cotação",
    heading: "Tem um requisito de filtração específico?",
    description: "Compartilhe suas especificações, desenhos ou requisitos de aplicação com nossa equipe.",
    button: "Solicitar orçamento",
    secondaryButton: "Fale conosco",
    standardNote: "EN 10204 3.1 (sob consulta)"
  }
};
export default function Manufacturing() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, ctaData);
  return <CtaBand id="final-cta" eyebrow={content.eyebrow} heading={content.heading} lead={content.description} primary={{
    label: content.button,
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryButton,
    to: "/ContactPage"
  }} note={content.standardNote} />;
}